import { React, useState } from "react";
import { Box, ModalBody } from "@chakra-ui/react";
import { XCircle } from "phosphor-react";
import Api from "../../..//Helper/ApiHandler";
import { COLORS } from "../../../Helper/Colors";
import InfiniteScroll from "react-infinite-scroll-component";
import { FriendProfileCart } from "./FriendProfileCart";
import { useEffect } from "react";
import { Search } from "../../../Components/Common/UI";
import TableLoader from "../../../Components/Common/TableLoader";
export const FriendListModal = ({ Id, onClose }) => {
  const [params, setParams] = useState({
    pageNo: 1,
    pageSize: 25,
    order: "DESC",
    sortBy: "id",
  });
  const api = new Api();
  const [totalData, setTotalData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalcount, setTotalCount] = useState();
  const [search, setSearch] = useState("");
  const [Loading, setLoading] = useState(false);

  const getCardData = async () => {
    setLoading(true);
    const userList = await api.post(`${"user/friend-list"}`, {
      page: page,
      userId: Id,
      search: search,
    });

    setLoading(false);

    setTotalCount(userList?.data[0]?.totalCount[0]?.count);
    let myarray1 = totalData;
    let myarray2 = userList.data[0].pages;
    let newarray = myarray1.concat(myarray2);

    setTotalData(newarray);
    setPage(page + 1);
  };
  useEffect(() => {
    getCardData();
  }, [search]);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      overflow={"auto"}
      padding={4}
      paddingBottom={2}
      backgroundColor="#F4F7F9"
    >
      <TableLoader isLoading={Loading} version={6} />
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingBottom={"2"}
      >
        <Box width={"90%"}>
          <Search
            search={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setParams({ ...params, pageNo: 1 });
              setTotalData([]);
              setPage(1);
            }}
            resetSearch={() => {
              setSearch("");
              setPage(1);
            }}
          />
        </Box>

        <XCircle
          height="25"
          width="25"
          onClick={onClose}
          cursor={"pointer"}
          color={COLORS.lightGray}
        />
      </Box>

      <ModalBody minHeight="500" margin="0" padding="0">
        <Box>
          <InfiniteScroll
            dataLength={totalData.length}
            next={getCardData}
            style={{ display: "flex", flexDirection: "column" }} //To put endMessage and loader to the top.
            hasMore={totalcount != totalData.length}
            height={"60vh"}
            className="design-scrollbar"
            loader={
              totalData.length ? (
                <h4>Loading...</h4>
              ) : (
                !Loading && (
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    width={"100%"}
                    height={"100%"}
                  >
                    No Data Found
                  </Box>
                )
              )
            }
            endMessage={<></>}
          >
            {totalData.map((currentvalue, index) => {
              return (
                <FriendProfileCart
                  data={currentvalue.friendData}
                  onClose={onClose}
                />
              );
            })}
          </InfiniteScroll>
        </Box>
      </ModalBody>
    </Box>
  );
};
